import { useCallback } from "react";

/**
 * Custom hook to start a trial period for the user.
 * It sends a PUT request to the server to initiate the trial and reloads the page upon success.
 */
export const useStartTrial = ({ token, user, setNotification }) => {
  const startTrial = useCallback(async () => {
    if (!token || !user?.id) return;

    const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
    const url = `${BASE_URL}user-collection/${user.id}/start-trial`;

    const res = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error(
        errorText || "Não foi possível iniciar o período de teste.",
      );
      if (setNotification)
        setNotification({
          message: errorText || "Não foi possível iniciar o período de teste.",
          type: "error",
          autoHide: true,
          duration: 3000,
        });
      return;
    }

    window.location.reload();
  }, [token, user?.id, setNotification]);

  return { startTrial };
};
